export const V1_RESET_NOTIFICATIONS = 'V1_RESET_NOTIFICATIONS'

export default () => ({
  type: V1_RESET_NOTIFICATIONS,
})
